import { render, staticRenderFns } from "./ClientDetailsContactActions.vue?vue&type=template&id=933745ca&scoped=true&"
import script from "./ClientDetailsContactActions.vue?vue&type=script&lang=js&"
export * from "./ClientDetailsContactActions.vue?vue&type=script&lang=js&"
import style0 from "./ClientDetailsContactActions.vue?vue&type=style&index=0&id=933745ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933745ca",
  null
  
)

export default component.exports